import 'typeface-montserrat';

const colors = {
  black: '#000000',
  white: '#FFFFFF',
  gold: '#8A714C',
  midGold: '#b1956a',
  lightGold: '#caa977',
  lightGrey: '#f7f7f7', // off white
  lightGrey2: '#fbfbfb',
  lightGrey3: '#eeeeee',
  lightGrey4: '#e8e8e8',
  lightGrey5: '#f7f7f7',
  lightGrey6: '#e1e1e1',
  lightGrey7: '#f5f4f5',
  darkGrey: '#4a4a4a',
  darkGrey2: '#5c5c5c',
  midGrey0: '#717274',
  midGrey1: '#252525',
  midGrey2: '#adadad',
  midGrey3: '#dbdcdc',
  midGrey4: '#E3E3E3',
  midGrey5: '#e5e5e5',
  midGrey6: '#979797',
  midGrey7: '#9b9b9b',
  red: '#ff3c55', // watermelon
  darkRed: '#d32f2f',
  green: '#4cb935', // leafy green
  orange: '#ff7147', // pinkish orange
  yellow: '#ffbe35', // mango
};

const text = {
  primary: colors.midGrey1,
  secondary: colors.black,
  disabled: colors.grey,
  preamble: colors.greyDark,
  hint: colors.orange,
  headerColor: colors.greyDark,
};

const font = {
  fontFamily: ['Montserrat', 'Open-Sans', 'sans-serif'],
};

const typography = {
  h1: {
    fontFamily: font.fontFamily.join(','),
    fontSize: '2.688rem',
    fontWeight: 600,
  },
  h2: {
    fontSize: '1.75rem',
    fontWeight: 500,
    fontFamily: font.fontFamily.join(','),
  },
  h3: {
    fontSize: '1.375rem',
    fontWeight: 700,
    fontFamily: font.fontFamily.join(','),
  },
  h4: {
    fontSize: '1.313rem',
    fontWeight: 600,
    fontFamily: font.fontFamily.join(','),
  },
  h5: {
    fontSize: '1.25rem',
    fontWeight: 700,
    fontFamily: font.fontFamily.join(','),
  },
  h6: {
    fontSize: '1.188rem',
    fontWeight: 600,
    fontFamily: font.fontFamily.join(','),
  },
  h7: {
    fontSize: '1.188rem',
    fontWeight: 700,
    fontFamily: font.fontFamily.join(','),
  },
  h8: {
    fontSize: '0.875rem',
    fontWeight: 600,
    fontFamily: font.fontFamily.join(','),
  },
  h9: {
    fontSize: '0.625rem',
    fontWeight: 700,
    fontFamily: font.fontFamily.join(','),
  },
  body1: {
    fontSize: '1.063rem',
    fontWeight: 600,
    fontFamily: font.fontFamily.join(','),
  },
  body2: {
    fontSize: '0.875rem',
    fontWeight: 600,
    fontFamily: font.fontFamily.join(','),
  },
  caption: {
    fontWeight: 600,
    fontFamily: font.fontFamily.join(','),
  },
};

const themeColors = {
  primary: colors.gold,
  secondary: colors.midGrey1,
  error: colors.red,
};

const border = {
  borderRadius: 4,
  borderWidth: 1,
  borderColor: colors.midGrey3,
  borderColorSelected: colors.gold,
  borderColorDisabled: colors.grey,
  borderColorHover: colors.midGrey2,
};

const button = {
  borderWidth: 2,
  borderColor: colors.greyDark,
  boxShadow: 'none',
  backgroundColorActive: colors.greyDark,
  backgroundColorDisabled: colors.grey,
  colorActive: colors.grey,
};

const background = {
  backgroundColor: colors.white,
  backgroundColorDisabled: colors.grey,
  boxShadow: 'none',
};

const input = {
  borderRadius: border.borderRadius,
  borderWidth: border.borderWidth,
  borderWidthDisabled: border.borderWidth,
  borderColor: border.borderColor,
  borderColorHover: border.borderColorHover,
  borderColorSelected: border.borderColorSelected,
  borderColorDisabled: border.borderColorDisabled,
  backgroundColor: colors.white,
  backgroundColorDisabled: colors.grey,
  colorDisabled: colors.white,
  fontSize: typography.body2.fontSize,
};

const chip = {
  borderWidth: border.borderWidth,
  borderRadius: border.borderRadius,
  borderColor: border.borderColor,
  backgroundColor: colors.midGrey4,
};

const autoComplete = {
  backgoundColorFocused: colors.midGrey1,
  colorFocused: colors.white,
};

const stepper = {
  color: colors.grey,
  colorActive: colors.green,
  colorComplete: colors.green,
};

const variables = {
  autoComplete,
  background,
  border,
  button,
  chip,
  colors,
  font,
  input,
  stepper,
  text,
  themeColors,
  typography,
};

export default variables;
